import React from "react";

/**
 * Keeps a widget crash from white-screening Pine.
 * The widget is a non-essential overlay — if it throws, it disappears and the
 * app carries on.
 */
export default class WidgetErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error, info) {
    console.error("[AskPineWidget] crashed, unmounting:", error, info);
  }

  render() {
    if (this.state.failed) return null;
    return this.props.children;
  }
}
